var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n\t.st1{opacity:0.3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,142.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C59.7,130.3,65,135.6,65,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,189.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,177.5,123.9,182.8,123.9,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,130.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,118.5,123.9,123.8,123.9,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,71.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,59.6,123.9,64.8,123.9,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,59.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,47.8,182.9,53.1,182.9,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,118.5c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,106.7,241.8,112,241.8,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,59.6c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,47.8,241.8,53.1,241.8,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,47.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,36,300.8,41.2,300.8,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,448.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,437,359.8,442.2,359.8,448.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,389.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,378,359.8,383.3,359.8,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,330.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,319,359.8,324.3,359.8,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,271.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,260.1,359.8,265.3,359.8,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,212.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,201.1,359.8,206.4,359.8,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,153.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,142.1,359.8,147.4,359.8,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,95c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,83.2,359.8,88.4,359.8,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.8,36c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C354.5,24.2,359.8,29.5,359.8,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,24.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,12.4,418.7,17.7,418.7,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,83.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,71.3,418.7,76.6,418.7,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.7,71.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C472.4,59.6,477.7,64.8,477.7,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.7,130.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C472.4,118.5,477.7,123.8,477.7,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.7,189.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C472.4,177.5,477.7,182.8,477.7,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.7,248.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C472.4,236.4,477.7,241.8,477.7,248.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.7,307.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C472.4,295.5,477.7,300.7,477.7,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.7,366.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C472.4,354.4,477.7,359.7,477.7,366.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,142.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,130.3,418.7,135.6,418.7,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,201.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,189.3,418.7,194.6,418.7,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,260.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,248.2,418.7,253.6,418.7,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,319c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,307.2,418.7,312.5,418.7,319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,378c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,366.2,418.7,371.5,418.7,378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.7,437c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C413.5,425.2,418.7,430.4,418.7,437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,106.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,95,300.8,100.2,300.8,106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,165.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,153.9,300.8,159.2,300.8,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,224.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,212.9,300.8,218.1,300.8,224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,283.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,271.8,300.8,277.1,300.8,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,342.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,330.8,300.8,336.1,300.8,342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,401.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,389.8,300.8,395.1,300.8,401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,460.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C295.5,448.7,300.8,454,300.8,460.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,177.5c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,165.7,241.8,171,241.8,177.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,236.4c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,224.7,241.8,230,241.8,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,295.5c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,283.6,241.8,288.9,241.8,295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,354.4c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,342.6,241.8,347.9,241.8,354.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,413.3c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,401.6,241.8,406.8,241.8,413.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,472.3c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C236.6,460.5,241.8,465.8,241.8,472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,118.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,106.7,182.9,112,182.9,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,177.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,165.7,182.9,171,182.9,177.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,236.4c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,224.7,182.9,230,182.9,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,295.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,283.6,182.9,288.9,182.9,295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,354.4c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,342.6,182.9,347.9,182.9,354.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,413.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,401.6,182.9,406.8,182.9,413.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,472.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C177.6,460.5,182.9,465.8,182.9,472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,248.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,236.4,123.9,241.8,123.9,248.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,307.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,295.5,123.9,300.7,123.9,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,366.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,354.4,123.9,359.7,123.9,366.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,425.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,413.3,123.9,418.7,123.9,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,484.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C118.6,472.3,123.9,477.6,123.9,484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,201.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C59.7,189.3,65,194.6,65,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,260.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C59.7,248.2,65,253.6,65,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,319c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C59.7,307.2,65,312.5,65,319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,378c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C59.7,366.2,65,371.5,65,378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,437c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C59.7,425.2,65,430.4,65,437z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,146.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C52.6,134.3,57.9,139.6,57.9,146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,193.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,181.5,116.8,186.8,116.8,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,134.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,122.5,116.8,127.8,116.8,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,75.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,63.5,116.8,68.8,116.8,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,63.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,51.8,175.8,57,175.8,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,122.5c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,110.7,234.8,116,234.8,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,63.5c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,51.8,234.8,57,234.8,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,51.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,40,293.8,45.2,293.8,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,452.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,440.9,352.7,446.2,352.7,452.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,393.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,382,352.7,387.3,352.7,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,334.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,323,352.7,328.3,352.7,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,275.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,264.1,352.7,269.3,352.7,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,216.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,205.1,352.7,210.4,352.7,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,157.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,146.1,352.7,151.4,352.7,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,98.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,87.2,352.7,92.4,352.7,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,40c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C347.4,28.2,352.7,33.5,352.7,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,28.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,16.4,411.7,21.7,411.7,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,87.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,75.3,411.7,80.6,411.7,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,75.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C465.4,63.5,470.7,68.8,470.7,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,134.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C465.4,122.5,470.7,127.8,470.7,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,193.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C465.4,181.5,470.7,186.8,470.7,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,252.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C465.4,240.4,470.7,245.8,470.7,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,311.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C465.4,299.4,470.7,304.7,470.7,311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,370.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C465.4,358.4,470.7,363.7,470.7,370.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,146.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,134.3,411.7,139.6,411.7,146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,205.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,193.3,411.7,198.6,411.7,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,264.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,252.2,411.7,257.5,411.7,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,323c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,311.2,411.7,316.5,411.7,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,382c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,370.2,411.7,375.5,411.7,382z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,440.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C406.4,429.2,411.7,434.4,411.7,440.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,110.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,98.9,293.8,104.2,293.8,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,169.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,157.9,293.8,163.2,293.8,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,228.7c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,216.9,293.8,222.1,293.8,228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,287.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,275.8,293.8,281.1,293.8,287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,346.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,334.8,293.8,340.1,293.8,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,405.6c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,393.8,293.8,399,293.8,405.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.8,464.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C288.4,452.7,293.8,458,293.8,464.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,181.5c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,169.7,234.8,175,234.8,181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,240.4c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,228.7,234.8,234,234.8,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,299.4c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,287.6,234.8,292.9,234.8,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,358.4c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,346.6,234.8,351.9,234.8,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,417.3c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,405.6,234.8,410.8,234.8,417.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,476.3c0,6.5-5.2,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C229.5,464.5,234.8,469.8,234.8,476.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,122.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,110.7,175.8,116,175.8,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,181.5c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,169.7,175.8,175,175.8,181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,240.4c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,228.7,175.8,234,175.8,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,299.4c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,287.6,175.8,292.9,175.8,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,358.4c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,346.6,175.8,351.9,175.8,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,417.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,405.6,175.8,410.8,175.8,417.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,476.3c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C170.5,464.5,175.8,469.8,175.8,476.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,252.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,240.4,116.8,245.8,116.8,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,311.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,299.4,116.8,304.7,116.8,311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,370.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,358.4,116.8,363.7,116.8,370.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,429.2c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,417.3,116.8,422.7,116.8,429.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,488.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8 C111.6,476.3,116.8,481.6,116.8,488.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,205.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C52.6,193.3,57.9,198.6,57.9,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,264.1c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C52.6,252.2,57.9,257.5,57.9,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,323c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C52.6,311.2,57.9,316.5,57.9,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,382c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C52.6,370.2,57.9,375.5,57.9,382z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,440.9c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.2-11.8-11.8c0-6.5,5.2-11.8,11.8-11.8 C52.6,429.2,57.9,434.4,57.9,440.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.9722ea789850870dac82d0788936eda8.svg";
export { ForwardRef as ReactComponent };